<template>
  <form
    @submit.prevent.stop=""
    v-if="pkg">
    <tabs
      :level="1"
      :is-fullwidth="true"
      :links="parkingFormTabsLinks"
      :current-tab="parkingFormTab"
      @changeView="parkingFormTab = $event"
      mode="emitter"
      class="is-border-bottom"></tabs>
    <div class="has-background-notification is-padding-left is-padding-right">
      <div class="is-size-6 has-text-white is-padding-top-xxsmall is-padding-bottom-xxsmall">
        <span class="icon is-small is-size-7 is-margin-right-xxsmall">
          <i class="fas fa-check-circle"></i>
        </span>
        <i>Information obligatoire pour la validation du formulaire</i>
      </div>
    </div>
    <div
      class="column is-12"
      v-show="parkingFormTab === 'FICHE_PARKING'">
      <div class="columns has-background-white-bis is-multiline is-padding-xsmall">
        <div
          class="column is-6">
          <r-label
            label="Typologie"
            :is-required="true"
            :red-check="hasCheck"
            :value="parking.lot_type"></r-label>
          <div class="control">
            <div class="select is-fullwidth">
              <select
                v-model="parking.lot_type"
                id="lot_type">
                <option :value="null">
                  Selectionnez un type
                </option>
                <option
                  v-for="(c, i) in filteredTypesList"
                  :value="c.value"
                  :key="i"
                  :id="c.value">
                  {{ c.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-12 is-padding-xsmall">
          <r-label
            label=""
            :is-required="false"></r-label>
          <div class="control">
            <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
              <div
                class="column is-3 has-background-white"
                v-for="e in filteredSubtypesList"
                :key="'subtype-' + e.value">
                <input
                  v-model="parking.lot_subtype"
                  :value="e.value"
                  name="subtypes"
                  :id="'subtype-' + e.value"
                  type="checkbox"
                  class="vadCheckradiocase is-fullwidth">
                <label :for="'subtype-' + e.value">{{ e.label }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <r-label
            label="Référence"
            :value="parking.ref"
            :red-check="false"></r-label>
          <div class="control">
            <v-input
              id="ref"
              name="ref"
              @input="parking.ref = $event"
              :model="parking.ref"
              :errors-bag="errors"
              v-validate="'required|min:2|max:20'"
              data-vv-value-path="val"
              data-vv-as="Référence">
            </v-input>
          </div>
          <p
            v-if="!parkingRefAvailable"
            class="help is-danger">
            La référence existe déjà
          </p>
        </div>
        <div class="column is-6"></div>
        <div class="column is-6">
          <r-label
            label="Prix immo HT"
            :value="parking.sale_price_ht"></r-label>
          <div class="control">
            <v-input
              :has-addons="true"
              id="sale_price_ht"
              name="sale_price_ht"
              @click="selectedInput = 'ht'"
              @input="updateSalePriceHt($event)"
              :model="parking.sale_price_ht"
              :number="true"
              input-type="number"
              v-validate="'decimal:2'"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Prix immo HT">
              <p
                v-if="selectedInput === 'ht'"
                class="control"
                slot="addonLeft">
                <a class="button is-square is-static is-border">
                  <i class="fal fa-check-circle"></i>
                </a>
              </p>
              <p
                class="control"
                slot="addonRight">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
        </div>
        <!-- <div class="column is-2">
          <div v-if="parking.sale_price_ht && parking.sale_price_ttc">
            <r-label label="TVA" for="tva" :is-required="false"></r-label>
            <div class="has-text-weight-bold has-text-black is-size-4">
              {{parking.sale_price_ht | tva(parking.sale_price_ttc) | prettyPrice}} %
            </div>
            <div class="has-text-weight-light has-text-black is-size-6">
              {{parking.sale_price_ttc - parking.sale_price_ht | prettyPrice}} €
            </div>
          </div>
        </div> -->
        <div class="column is-6">
          <r-label
            label="Sélectionnez tva"
            :is-required="false"
            :value="parking.sale_price_ht"></r-label>
          <div class="columns column">
            <div class="is-padding-right-xxsmall">
              <button
                :disabled="!(parking.sale_price_ht || parking.sale_price_ttc)"
                :class="{'disabled' : !(parking.sale_price_ht || parking.sale_price_ttc)}"
                @click="updateTtc(0)"
                class="button">
                0%
              </button>
            </div>
            <div class="is-padding-right-xxsmall">
              <button
                :disabled="!(parking.sale_price_ht || parking.sale_price_ttc)"
                :class="{'disabled' : !(parking.sale_price_ht || parking.sale_price_ttc)}"
                @click="updateTtc(5.5)"
                class="button">
                5.5%
              </button>
            </div>
            <div class="is-padding-right-xxsmall">
              <button
                :disabled="!(parking.sale_price_ht || parking.sale_price_ttc)"
                :class="{'disabled' : !(parking.sale_price_ht || parking.sale_price_ttc)}"
                @click="updateTtc(7)"
                class="button">
                7.0%
              </button>
            </div>
            <div class="is-padding-right-xxsmall">
              <button
                :disabled="!(parking.sale_price_ht || parking.sale_price_ttc)"
                :class="{'disabled' : !(parking.sale_price_ht || parking.sale_price_ttc)}"
                @click="updateTtc(10)"
                class="button">
                10.0%
              </button>
            </div>
            <div class="is-padding-right-xxsmall">
              <button
                :disabled="!(parking.sale_price_ht || parking.sale_price_ttc)"
                :class="{'disabled' : !(parking.sale_price_ht || parking.sale_price_ttc)}"
                @click="updateTtc(20)"
                class="button">
                20%
              </button>
            </div>
          </div>
        </div>
        <div class="column is-6 is-narrow">
          <div class="field">
            <r-label
              :is-required="false"
              label="Tva"
              :value="tva"
              :truncate="false"></r-label>
            <div class="control">
              <v-input
                :has-addons="true"
                id="tva"
                name="tva"
                :model="tva"
                input-type="number"
                v-validate="''"
                :disabled="true"
                :errors-bag="errors"
                data-vv-value-path="val"
                :number="true">
                <p
                  class="control"
                  slot="addonRight">
                  <a class="button is-grey is-square is-static">
                    <span class="icon"><i class="fas fa-percentage"></i></span>
                  </a>
                </p>
              </v-input>
            </div>
          </div>
          <div
            class="has-text-weight-light is-size-6"
            v-if="tvaAmount">
            ({{ tvaAmount | prettyPrice }} €)
          </div>
        </div>
        <div class="column is-6">
          <r-label
            :label="'Prix immo TTC'"
            :value="parking.sale_price_ttc"></r-label>
          <div class="control is-expanded">
            <v-input
              :has-addons="true"
              id="sale_price_ttc"
              name="sale_price_ttc"
              @click="selectedInput = 'ttc'"
              @input="updateSalePrice($event)"
              :model="parking.sale_price_ttc"
              input-type="number"
              v-validate="'required|decimal:2'"
              :errors-bag="errors"
              data-vv-value-path="val"
              :number="true"
              data-vv-as="Prix immo TTC">
              <p
                v-if="selectedInput === 'ttc'"
                class="control"
                slot="addonLeft">
                <a class="button is-square is-static is-border">
                  <i class="fal fa-check-circle"></i>
                </a>
              </p>
              <p
                class="control"
                slot="addonRight">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-euro-sign"></i></span>
                </a>
              </p>
            </v-input>
          </div>
        </div>
        <div
          class="column is-12"
          v-if="showStatusSelect && !hasCheck">
          <r-label
            label="Statut d'édition du parking"
            for="tags"
            :is-required="false"></r-label>
          <div class="columns is-gapless is-multiline has-cloud-checkradiocase">
            <div
              class="column is-3 has-background-white"
              v-for="s in availableLotStatusList"
              :key="'parkingStatus-' + s.value">
              <input
                v-model="parking.status"
                :value="s.value"
                :disabled="!isAdmin"
                :name="'parkingStatus'"
                :id="'parkingStatus-' + s.value"
                type="radio"
                class="vadCheckradiocase is-fullwidth">
              <label :for="'parkingStatus-' + s.value">{{ s.label }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="column is-12"
      v-show="parkingFormTab === 'DOCS'">
      <div class="columns is-padding-xsmall has-background-white columns is-multiline">
        <div class="column is-12 is-paddingless-bottom">
          <div class="title is-5">
            <b class="is-uppercase">Plan du parking</b>
            <span
              class="is-padding-left-xsmall"
              v-helper.bottom="'4KFS6RMsZXkFpEYgFDzsuZ'">
              <i class="fal fa-info-circle"></i>
            </span>
          </div>
        </div>
        <div class="column is-12">
          <upload-file
            :custom-id="'plan'"
            :source-documents="parking.plan ? [parking.plan] : []"
            :unique="true"
            @upload="uploadDocument({ files: $event, target: 'plan' })"
            @deleteDocument="deleteDocument({ target: 'plan', unique: true })"></upload-file>
        </div>
      </div>
      <div class="columns is-padding-xsmall has-background-light columns is-multiline">
        <div class="column is-12 is-paddingless-bottom">
          <div class="title is-5">
            <b class="is-uppercase">Documents</b>
            <span
              class="is-padding-left-xsmall"
              v-helper.bottom="'4KFS6RMsZXkFpEYgFDzsuZ'">
              <i class="fal fa-info-circle"></i>
            </span>
          </div>
          <tabs
            :links="documentsTabs"
            :level="1"
            :current-tab="documentsTab"
            classes="has-background-light"
            mode="emitter"
            @changeView="documentsTab = $event"
            :is-fullwidth="true"></tabs>
        </div>
        <div class="column is-12">
          <div>
            <!-- <label class="label">Téléchargez des documents</label> -->
            <upload-file
              :custom-id="'documents'"
              :placeholder="'Sélectionner document(s)'"
              :source-documents="documentsToDisplay"
              :has-destination="true"
              :destinations-list="lotDestinations"
              :hide-upload="documentsTab !== 'DOCUMENTS'"
              @upload="uploadDocument({ files: $event })"
              @deleteDocument="deleteDocument({ document: $event })"></upload-file>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 is-paddingless-left is-paddingless-right">
      <submit-sticky-buttons
        @submit="submit"
        :loading="submitLoading"
        button-id="parkingForm"></submit-sticky-buttons>
    </div>
  </form>
</template>

<script>
import LotMixin from '@/components/lots/LotMixin'

export default {
  name: 'ParkingForm',
  mixins: [LotMixin],
  data () {
    return {
      parkingMode: true,
      formMode: true,
      parkingFormTab: 'FICHE_PARKING'
    }
  },
  computed: {
    tva () {
      return Number((this.parking.sale_price_ttc - this.parking.sale_price_ht) * 100 / this.parking.sale_price_ht).toFixed(2)
    },
    showStatusSelect () {
      if (this.parking && 'status' in this.parking) {
        return ['draft', 'available'].includes(this.parking.status)
      }
      return null
    },
    filteredTypesList () {
      return this.typesList.filter((x) => x.show.includes(this.parking.nature))
    },
    filteredSubtypesList () {
      console.log(this.parking)
      return this.subtypesList.filter((x) => x.show.includes(this.parking.nature))
    },
    parkingFormTabsLinks () {
      return [
        { link: 'FICHE_PARKING', label: 'Fiche du parking' },
        { link: 'DOCS', label: 'Documents', disable: this.newParking }
      ]
    }
  },
  watch: {
    sourceLotProgram (v) {
      if (v) this.updateSources({ program: v })
    },
    'parking.ref' (to, from) {
      if (!this.formMode) return
      if (!to || !from) return
      let previousVal = from
      this.parking.ref = to
      if (this.parking.ref !== previousVal && to.length >= 2) {
        this.verifyAvaibilityLotRef(to)
      }
    }
  },
  created () {
    console.log(this.parking)
    if (this.$route.query && this.$route.query.panel) {
      this.parkingFormTab = this.$route.query.panel
    }
  },
  methods: {
    submit () {
      console.log(this.parking)
      this.$emit('submit', this.parking)
    },
    duplicateLotForm (parking) {
      parking.pk = null
      parking.ref = null
      parking.status = 'draft'
      parking.plan = null
      parking.documents = []
      parking.program = parking.program.pk
      parking.promoteur = parking.promoteur.pk
      delete parking.tax_dispositifs
    }
  }
}
</script>
